import { BoolNumber, TRUE } from 'base/utils/soccerHelpers';

export function validateLineBets(betMatchLine: BoolNumber[][]): boolean {
    if (betMatchLine.length === 0) {
        return false;
    }

    const betsCount = betMatchLine.filter((matchBets) => matchBets.filter((bet) => bet === TRUE).length > 0).length;
    // @ToDo: Replace 15 and 14 with a constant getting from the lottery_rules
    const specialBetsValid = betMatchLine.length === 15 && betMatchLine[14].filter((bet) => bet === TRUE).length > 1;

    return betsCount === betMatchLine.length && specialBetsValid;
}

export function calculateStakesByLineBets(betMatchLines: BoolNumber[][][]): number[] {
    const stakes = [];

    betMatchLines.forEach((betMatchLine, lineIndex) => {
        stakes[lineIndex] = 1;
        betMatchLine.forEach((matchBets, matchIndex) => {
            // @ToDo: Replace 14 with a constant getting from the lottery_rules
            if (matchIndex < 14 && matchBets.filter((bet) => bet === TRUE).length > 1) {
                // Multiple stake for extra bets
                stakes[lineIndex] *= 2;
            }
        });
    });

    return stakes;
}
